import React, {useMemo} from "react";
import {routeFunctions} from "../../../../../core/models/static/routes/app-routes";
import {htmlToString} from "../../../../../core/services/utils/utils";
import {Link} from "react-router-dom";
import LazyImage from "../../lazy-image";
import DateUtils from "../../../../../core/services/date-utils";
import {Card} from "@mui/material";

const ContentBlog = ({data}) => {
    const link = useMemo(() => routeFunctions.content.blogs.single(data?.slug), [data?.slug])

    return (
        <>
            <Card variant={'outlined'} component={Link} to={link} className={'blog'}>
                <div className={'blog-inner'}>
                    <div className={'image-container'}>
                        <LazyImage src={data.coverImage?.srcUrl} alt={'Cover Image'}/>
                    </div>
                    <div className={'content-container'}>
                        <div className={'d-flex flex-column'}>
                            <p className={'title'}>
                                {data?.title}
                            </p>
                            <p className={'date'}>
                                {
                                    data?.lastModifyDateTime
                                        ? DateUtils.serverToLocal(data.lastModifyDateTime).format(DateUtils.dateFormatAlternative)
                                        : ''
                                }
                            </p>
                        </div>
                        <div className="description">
                            <p>
                                {htmlToString(data?.bodyContent, 110)}
                            </p>
                        </div>
                        <div className={'d-flex justify-content-end w-100'}>
                            <p className={'action'}>
                                Read More
                            </p>
                        </div>
                    </div>
                </div>
            </Card>
        </>
    )
}

export default ContentBlog;
